var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.5 17C3.875 17 3.42361 16.7188 3.14583 16.1563C2.86806 15.5938 2.92361 15.0694 3.3125 14.5833L7.5 9.5V4.5H6.75C6.54167 4.5 6.36458 4.42708 6.21875 4.28125C6.07292 4.13542 6 3.95833 6 3.75C6 3.54167 6.07292 3.36458 6.21875 3.21875C6.36458 3.07292 6.54167 3 6.75 3H13.25C13.4583 3 13.6354 3.07292 13.7812 3.21875C13.9271 3.36458 14 3.54167 14 3.75C14 3.95833 13.9271 4.13542 13.7812 4.28125C13.6354 4.42708 13.4583 4.5 13.25 4.5H12.5V9.5L16.6875 14.5833C17.0903 15.0694 17.1528 15.5938 16.875 16.1563C16.5972 16.7188 16.1389 17 15.5 17H4.5ZM6.625 14.5H13.375L10.7917 11.3333H9.20833L6.625 14.5ZM4.5 15.5H15.5L11 10V4.5H9V10L4.5 15.5Z",
    fill: "#5A2810"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile3);
export default __webpack_public_path__ + "static/media/profile-3.2b23f6ebfcdc4cffb7b8acacd491b50d.svg";
export { ForwardRef as ReactComponent };